import React, { Component } from 'react';
import './site.scss';
import './_mixins.scss';
import TextInput from "../components/common/TextInput";
import NumberInput from "../components/common/NumberInput";

class StyleGuidePage extends Component {
	// constructor(props, context) {
	// 	super(props, context);
	// }
  render() {										
    return (
			<div>
			<section className='container'>
			<header className="row">
      	<div className="col">
					<h1>StyleGuide Heading <small>- h1</small></h1>
					<h2>Alternate Heading <small>- h2</small></h2>
					<h3>Heading - h3</h3>
					<h4>Heading - h4</h4>
					<h5>Heading - h5</h5>
					<h6>Heading - h6</h6>
				</div>
			</header>
			</section>
			
			<section className='container'>
			<div className="row">
			<div className="col">

				<h2>Sem et Tortor Consequat</h2>

				<img className="alignright" src='https://via.placeholder.com/300' />
				<p><strong>Lorem ipsum dolor sit amet</strong>, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Rhoncus aenean vel elit scelerisque mauris pellentesque pulvinar pellentesque. Non arcu risus quis varius quam quisque id diam. Dictum non consectetur a erat. <em>Ornare lectus sit amet</em> est placerat in egestas. Dolor magna eget est lorem ipsum. Enim diam vulputate ut pharetra sit amet aliquam id diam. Ac feugiat sed lectus vestibulum. Diam ut venenatis tellus in metus. Volutpat odio facilisis mauris sit amet massa. Habitant morbi tristique senectus et. Id venenatis a condimentum vitae sapien pellentesque. Est placerat in egestas erat imperdiet sed euismod nisi. Nulla aliquet porttitor lacus luctus accumsan tortor posuere. Tincidunt ornare massa eget egestas purus viverra accumsan in. Bibendum est ultricies integer quis auctor elit sed.
				</p>

				<p>Semper feugiat nibh sed pulvinar. Sollicitudin ac orci phasellus egestas. Tortor dignissim convallis aenean et tortor. Eget est lorem ipsum dolor sit amet consectetur. Est sit amet facilisis magna etiam tempor orci eu lobortis. Gravida cum sociis natoque penatibus et magnis dis. Pellentesque nec nam aliquam sem et tortor consequat id porta. Metus aliquam eleifend mi in. Et molestie ac feugiat sed lectus vestibulum mattis. Elit ullamcorper dignissim cras tincidunt lobortis feugiat. Id interdum velit laoreet id donec ultrices tincidunt arcu non. Facilisi nullam vehicula ipsum a arcu cursus vitae congue mauris. Id porta nibh venenatis cras. Eget aliquet nibh praesent tristique magna sit amet purus gravida. Egestas quis ipsum suspendisse ultrices gravida dictum fusce. Et ultrices neque ornare aenean euismod elementum nisi quis eleifend. Sed odio morbi quis commodo odio aenean sed adipiscing. Viverra maecenas accumsan lacus vel. Scelerisque eleifend donec pretium vulputate. Ut pharetra sit amet aliquam.</p>

				<blockquote>
				Elit ullamcorper dignissim cras tincidunt lobortis feugiat. Id interdum velit laoreet id donec ultrices tincidunt arcu non. Facilisi nullam vehicula.
				</blockquote>

			</div>
			</div>
			<div className="row">
			<div className="col">
				<h2>Sem et Tortor Consequat</h2>
			</div>
			</div>
			<div className="row">
			<div className="col">
				<img className="alignleft" src='https://via.placeholder.com/220' />
				<p>Porta non pulvinar neque laoreet. Ac feugiat sed lectus vestibulum. Et netus et malesuada fames ac turpis. Ac auctor augue mauris augue neque. Phasellus egestas tellus rutrum tellus pellentesque eu tincidunt tortor. Eu mi bibendum neque egestas congue quisque egestas diam. Et tortor at risus viverra adipiscing at in tellus. Tincidunt id aliquet risus feugiat in ante metus dictum at.</p>
			</div>
			<div className="col">
				<p>Egestas dui id ornare arcu odio ut sem. Aliquet porttitor lacus luctus accumsan tortor posuere ac ut consequat. Risus quis varius quam quisque id diam vel quam elementum. Mattis molestie a iaculis at erat pellentesque. Vitae ultricies leo integer malesuada nunc vel risus commodo. Eu sem integer vitae justo. Facilisis gravida neque convallis a cras. Lacinia quis vel eros donec ac odio tempor orci. Velit dignissim sodales ut eu sem integer. Consectetur adipiscing elit pellentesque habitant morbi tristique senectus et netus. Nisi porta lorem mollis aliquam ut porttitor. Tellus.
					</p>
			</div>
			<div className='col'>
				<p>rutrum tellus pellentesque eu tincidunt tortor aliquam nulla. A pellentesque sit amet porttitor eget. Est velit egestas dui id ornare arcu. Consequat mauris nunc congue nisi vitae suscipit tellus mauris a. Mauris rhoncus aenean vel elit scelerisque mauris. Id diam maecenas ultricies mi eget mauris pharetra. Quis eleifend quam adipiscing vitae proin sagittis nisl rhoncus mattis. Nulla pellentesque dignissim enim sit amet venenatis. Gravida rutrum quisque non tellus orci ac auctor.</p>
				
				<p>Varius duis at consectetur lorem donec massa sapien faucibus et. Morbi tristique senectus et netus et. Nunc pulvinar sapien et ligula ullamcorper malesuada proin libero nunc.</p> 
				
			</div>
			</div>
			<hr />
			</section>

			<section className="container">

				<header className="row"><div className="col"><h1>Form Elements</h1></div></header>
				<div className="row">
					<form className="col">
					<TextInput
						name="company"
						label="Company Name" />
					
					<NumberInput
						name="associates"
						label="Number of Associates"
						error={"A big error happened here."} />
					<br />	
					<input type="submit" className="btn" />
					</form>
					<div className="col">
					<br />
					<br />
						<a className="btn">.btn</a>
						<br />
						<br />
						<a className="btn reverse">.btn.reverse</a>
						<br />
						<br />
						<a className="btn done">.btn.done</a>
						<br />
						<br />
						<a className="btn large">.btn.large</a>
						<br />
						<br />
						<a className="btn reverse large">.btn.reverse.large</a>
						<br />
						<br />
						<a className="btn done large">.btn.done.large</a>
					</div>
					
				</div>
				
				<div className="row">
					<br />
				</div>

			</section>
			<section id="textured-card">
			<div className="row">
				<div className="col">
					<img src="/wp-content/uploads/2018/10/experience-the-bsi-showroom.jpg" alt="BSI showroom setting"/>
				</div>
				<div className="col">
					<hr className="graphic" />
					<h2>Graphic Texture<br /> 
							Card</h2>
					<p>Egestas quis ipsum suspendisse ultrices gravida dictum fusce.</p>
					<a class="btn" href="/404">Call to Action</a>
				</div>
			</div>
		</section>
		</div>

    );
  }
}

export default StyleGuidePage;



// WEBPACK FOOTER //
// ./src/styles/StyleGuidePage.js